import { useEffect, useState } from 'react'

/**
 * Determines whether or not this is a touch screen device.
 */
const useIsTouchDevice = (): boolean => {
  const [isTouchDevice, setIsTouchDevice] = useState<boolean>(false)

  useEffect(() => {
    setIsTouchDevice(!!('ontouchstart' in window))
  }, [])

  return isTouchDevice
}

export default useIsTouchDevice
